import { Group, Title } from '@mantine/core';
import React from 'react';
import DataTable from 'react-data-table-component';
import ActionCell from './components/ActionCell';
import useGetSubscription from './useGetSubscription';
import LoadingErrorContainer from '../../components/placeholders/LoadingErrorContainer';

const Remote = () => {

    const { SubscriptionQuery: {
        data, isPending, isError, isRefetching },

    } = useGetSubscription()

    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Months',
            selector: row => row.months,
            sortable: true,
        },
        {
            name: 'IOS Amount',
            selector: row => row.amount,
            sortable: true,
        },
        {
            name: 'Android Amount',
            selector: row => row.android_amount,
            sortable: true,
        },
        {
            name: 'IOS Product Id',
            selector: row => row.apple_product_id ?? 'N/A',
            sortable: true,
        },
        {
            name: 'Android Product Id',
            selector: row => row.google_product_id ?? 'N/A',
            sortable: true,
        },
        {
            name: 'Action',
            cell: row => <ActionCell row={row} />,
        },
    ];



    return (
        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            <Group justify='space-between'>
                <Title order={3}>Subscriptions</Title>

            </Group>
            <DataTable
                columns={columns}
                data={data ?? []}
                progressPending={isPending}




            // selectableRows

            />

        </LoadingErrorContainer>


    );

}

export default Remote;
